module.exports = __webpack_public_path__ + "img/loading.5780b10b.gif";